import { render } from "./UserCommission.vue?vue&type=template&id=2dc1334b&scoped=true"
import script from "./UserCommission.vue?vue&type=script&lang=js"
export * from "./UserCommission.vue?vue&type=script&lang=js"

import "./UserCommission.vue?vue&type=style&index=0&id=2dc1334b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc1334b"]])

export default __exports__